import createStore from "@Stores/base-factories"
import hookSiteSelectedFactory from "@Stores/base-factories/store-site-selection"

const { Provider, useStore } = createStore()
  .extend(hookSiteSelectedFactory('siteId'))
  .extendReportFactory()
  .extendReportViewFactory('progression')
  .factory()

export {
  Provider as ProgressionReportProvider,
  useStore as useProgressionReportStore,
}
